import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button, Form, Input, Flex, Row, Col, Divider, Typography, Space, message, Select, Radio, Modal, Checkbox, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import one_source_connect from '../../assets/images/one_source_connect.png';
import commonService from '../../services/CommonService';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Link from 'antd/es/typography/Link';
import { convertCompanyDataToSelectOptions, decryptURL } from '../../utils/commonUtil';
import { setWoBrandNames, setBrandNamesCertProjects, setBrandNamesWithIAProjects, setCertIAUploadProjectBrandNames, setBrandNames, setSubscriptionDetails, setClientProductlst, setWoCountry, setWoModelNames, setCountryCertProjects, setBvCertLocations, setBvLocations, setCertExpInSixMonthCount, setCertRenewalReminderCount, setClientList, setFactoryAuditNotifyCount, setIsParentClient, setLastTwoMonthUpdRegCount, setLoggedInClient, setModelNames, setModelNamesWithIAProjects, setReqUpdLastTwoMonthCount, setSelClientList, setUserRoleStored, setVendorClients, setVendorSubPrjCountries, setVendorSubProjServiceTypes, setVendorSubProjProdSubSeg, setVendorSubProjTechType, setVendorSubProjAssignees, setVendorSubProjBussinessUnits, setVendorSubProjBrandNames, setVendorPortalNotificationList, setCountryTerritoryList, setDocumentStatusList, setRegionCountryList, setMainProductTypeList, setTechnologyTypeList, setServiceTypeList, setProductTypeList, setVendorCurrencyList, setVendorSampleList, setClientProfileDetails, setIsAuthenticated, setProjectPieChartSearchList, setCompanyId, setModelNamesCertProjects, setClientUserScreenAccess, clearState, setLstClientVendor } from '../../context/reducers/userReducer';
import { useDispatch } from 'react-redux';
import { getOrderedJson } from '../../utils/bvUtil';
import { API_CONSTANTS, UserActivity } from '../../config/BVConstants';
import mdmService from '../../services/MDMService';
import { useSelector } from 'react-redux';
import _ from 'lodash';
const LoginPage = () => {
    const [validateOTP, setValidateOTP] = useState(false);
    const [noOfAttempts, setNoOfAttempts] = useState(0);
    const [waitTimeInMin, setWaitTimeInMin] = useState(0);
    const [companies, setCompanies] = useState([]);
    const [enteredOTP, setEnteredOTP] = useState();
    const [showUserRoleMenu, setShowUserRoleMenu] = useState(false);
    const [showCompSelMenu, setShowCompSelMenu] = useState(false);
    const [isResendOTPBttnDisabled, setIsResendOTPBttnDisabled] = useState(true);
    const [timer, setTimer] = useState(30);
    const [messageApi, contextHolder] = message.useMessage();
    const [userDetail, setUserDetail] = useState();
    const [selCompanyId, setSelCompanyId] = useState();
    const [dimensions, setDimensions] = useState({ height: 0, width: 0 });
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [btnItrLoading, setBtnItrLoading] = useState(false);
    const [btnOvrItrLoading, setBtnOvrItrLoading] = useState(false);
    const [btnClientVendorLoading, setBtnClientVendorLoading] = useState(false);
    const applicationData = useSelector((state) => state.applicationData);
    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    const [form] = Form.useForm();
    const Message = (type, content) => {
        messageApi.open({
            type: type,
            content: content,
        });
    };
    const setResendButtonTimmer = () => {
        const interval = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer === 1) {
                    clearInterval(interval);
                    setIsResendOTPBttnDisabled(false);
                    return 30;
                }
                return prevTimer - 1;
            });
        }, 1000);
    };
    let isChecked = false;
    const handleCheckboxChange = (e) => {
        isChecked = e.target.checked;
    };
    const handleconsentOk = (email) => {
        if (!isChecked) {
            model(email);
            Message("error", "Please accept terms and conditions.");
            return;
        }
        else {
            commonService.updateConsentAcceptedDateByEmail([{ strLoggedInUser: email }]).then((res) => {
            });
        }
    };
    const handleconsentCancel = () => {
        dispatch(clearState());
        window.location.reload();
    };
    const handleLogin = (userRole, companyId, strNavigate) => {
        if (companyId) {
            //for login Authentication flag
            dispatch(setIsAuthenticated(true));
            dispatch(setUserRoleStored(userRole));
            commonService.getLoggedInUserDetails({ strLoginName: userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId, intCompanyId: companyId })
                .then((res) => {
                var _a;
                dispatch(setSubscriptionDetails(res.objAccessRoleResponse));
                setBtnItrLoading(false);
                setBtnClientVendorLoading(false);
                const user = Object.assign(Object.assign({}, res), { strUserEmailId: (_a = userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId) !== null && _a !== void 0 ? _a : '' });
                const userWrapper = {
                    userLoginDetails: user,
                };
                dispatch(setLoggedInClient(userWrapper));
                if (userRole === 1) {
                    commonService.logUserActivity(userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId, UserActivity.CP__Login);
                    commonService
                        .checkIsParentCompany({ intId: companyId, strLoggedInUser: userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId })
                        .then((res) => {
                        dispatch(setIsParentClient(res));
                    });
                    let isMapClientIdPresent = false;
                    dispatch(setCompanyId(companyId));
                    commonService
                        .getMapClientID({ intId: companyId, strLoggedInUser: userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId })
                        .then((res) => {
                        if (!_.isEmpty(res) && !_.isNil(res)) {
                            isMapClientIdPresent = true;
                            dispatch(setClientList(res));
                            handleClientInitialisation(res, companyId, strNavigate);
                        }
                    });
                    let isClientDataFound = false;
                    if (!isMapClientIdPresent) {
                        commonService
                            .getIndividualClientsMap({ intId: companyId, strLoggedInUser: userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId })
                            .then((res) => {
                            if (res) {
                                isClientDataFound = true;
                                handleClientInitialisation([Object.assign({}, res)], companyId, strNavigate);
                            }
                        });
                    }
                    if (!isClientDataFound) {
                        handleClientInitialisation([{ intId: companyId }], companyId, strNavigate);
                    }
                }
                else if (userRole === 2) {
                    commonService.logUserActivity(userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId, UserActivity.VP__Login);
                    fetchVendorRelatedData(companyId);
                    dispatch(setCompanyId(companyId));
                    navigate('/vendor');
                }
                dispatch(setUserRoleStored(userRole));
                fetchBasicData();
            });
        }
    };
    useEffect(() => {
        if (isResendOTPBttnDisabled) {
            setResendButtonTimmer();
        }
    }, [isResendOTPBttnDisabled]);
    useEffect(() => {
        if (companies && (companies.length === 1)) {
            setSelCompanyId(companies[0].intCompanyID);
        }
        else if (companies && (companies.length > 1)) {
            setShowCompSelMenu(true);
        }
    }, [companies]);
    const handleIntermediateLogin = (strUserEmailId) => {
        setBtnOvrItrLoading(true);
        commonService
            .getUserAssociatedCompanyList(strUserEmailId).then(companies => {
            var _a;
            dispatch(setLstClientVendor(companies));
            setBtnOvrItrLoading(false);
            if (companies.length === 1) {
                handleClientVendor((_a = companies[0]) === null || _a === void 0 ? void 0 : _a.companyId);
            }
            else {
                setCompanies(companies);
            }
        });
    };
    const handleClientVendor = (companyId) => {
        setSelCompanyId(companyId);
        commonService.getVendorInfo(companyId)
            .then((res) => {
            commonService.getClientUserScreenAccess([{ strLoggedInUser: userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId, intId: companyId }]).then((screenRes) => {
                dispatch(setClientUserScreenAccess(screenRes));
                if (res && res.boolIsAlsoClient) {
                    setBtnItrLoading(false);
                    setShowUserRoleMenu(true);
                    setShowCompSelMenu(false);
                }
                else if (res) {
                    handleLogin(2, companyId, '');
                }
                else {
                    isClient(companyId);
                }
            });
        });
    };
    useEffect(() => {
        var _a, _b, _c;
        if (searchParams.get("redirect") != null && searchParams.get("redirect") != '') {
            const decryptedString = decryptURL(searchParams.get("redirect") || '');
            const val = decryptedString.split(",");
            if (val[1] != null && val[0] != null) {
                const user = val[0].split("_");
                const strLoginName = user[user.length - 1];
                form.setFieldsValue({
                    strUserEmailId: strLoginName
                });
                handleSubmitForm(form.getFieldValue('strUserEmailId'));
            }
        }
        else if (searchParams.get("id") != null && searchParams.get("id") != '') {
            form.setFieldsValue({
                strUserEmailId: searchParams.get("id")
            });
            handleSubmitForm(form.getFieldValue('strUserEmailId'));
        }
        else if (applicationData.isAuthenticated != undefined && applicationData.isAuthenticated && applicationData.loggedInClient && applicationData.loggedInClient != undefined) {
            setUserDetail((_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails);
            if ((_c = (_b = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _b === void 0 ? void 0 : _b.userLoginDetails) === null || _c === void 0 ? void 0 : _c.strUserEmailId) {
                handleIntermediateLogin(applicationData.loggedInClient.userLoginDetails.strUserEmailId);
            }
        }
    }, []);
    const handleClientInitialisation = (res, companyId, strNavigate) => {
        let company = Object.assign({ strLoggedInUser: userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId }, _.find(res, (item) => item.intId === companyId));
        dispatch(setSelClientList(Object.values({ company })));
        fetchClientRelatedData(Object.values({ company }), companyId, dispatch);
        navigate(strNavigate);
    };
    const handleSubmitForm = (value) => {
        const button = document.getElementById('generateOTPButton');
        if (button && (value != null && value != undefined && value != '')) {
            button.click();
        }
    };
    const onFinish = (values) => {
        if (validateOTP) {
            let userObj = Object.assign({ strEnteredOTP: enteredOTP || '' }, userDetail);
            if (userObj.strEnteredOTP && (!/^[0-9]{6}$/.test(userObj.strEnteredOTP))) {
                messageApi.open({
                    type: 'error',
                    content: 'OTP must be 6 digits number!',
                });
            }
            else {
                commonService.verifyOTPForApprClientLogin(userObj).then((res) => {
                    if (res) {
                        setUserDetail(res);
                        setNoOfAttempts(res.intOTPNumberOfAttempts || 0);
                        if (res === null || res === void 0 ? void 0 : res.boolIsValidOTP) {
                            messageApi.open({
                                type: 'success',
                                content: 'OTP verified',
                            });
                            commonService.getClientUserConsentFlag([{ strLoggedInUser: userObj.strUserEmailId }]).then((res) => {
                                if (res === 0) {
                                    model(`${userObj.strUserEmailId}`);
                                }
                            });
                            const redirect = searchParams.get("redirect");
                            if (redirect) {
                                const decryptedString = decryptURL(redirect);
                                const strUrlParam = decryptedString.split(",");
                                commonService.getClientUserScreenAccess([{ strLoggedInUser: userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId, intId: strUrlParam[1] }]).then((screenRes) => {
                                    dispatch(setClientUserScreenAccess(screenRes));
                                    if (strUrlParam[2] === "CERT") {
                                        handleLogin(1, parseInt(strUrlParam[1]), '/certificates?K=' + redirect);
                                    }
                                    else if (strUrlParam[2] === "REG") {
                                        const regId = strUrlParam[3] ? btoa(strUrlParam[strUrlParam.length - 1].toString()) : '';
                                        handleLogin(1, parseInt(strUrlParam[1]), '/regulatory-library-details/' + regId);
                                    }
                                });
                            }
                            else {
                                if (res.strUserEmailId) {
                                    handleIntermediateLogin(res.strUserEmailId);
                                }
                            }
                        }
                        else {
                            messageApi.open({
                                type: 'error',
                                content: 'OTP verification unsuccessfull',
                            });
                            if ((res === null || res === void 0 ? void 0 : res.intOTPNumberOfAttempts)
                                && (res === null || res === void 0 ? void 0 : res.intOTPNumberOfAttempts) >= 5) {
                                handleAttemptExceed(res);
                            }
                        }
                    }
                });
            }
        }
        else {
            setLoading(true);
            commonService.generateOTPForApprClientLogin(values).then((res) => {
                setLoading(false);
                setUserDetail(res);
                setNoOfAttempts((res === null || res === void 0 ? void 0 : res.intOTPNumberOfAttempts) || 0);
                if (res && res.boolOTPSent) {
                    setValidateOTP(true);
                    messageApi.open({
                        type: res.boolOTPSent ? 'success' : 'error',
                        content: res.strOTPLoginMssg,
                    });
                }
                if (!res.boolOTPSent) {
                    messageApi.open({
                        type: 'error',
                        content: res.strOTPLoginMssg,
                    });
                }
                if ((res === null || res === void 0 ? void 0 : res.intOTPNumberOfAttempts) && (res === null || res === void 0 ? void 0 : res.intOTPNumberOfAttempts) >= 5) {
                    handleAttemptExceed(res);
                }
            });
        }
    };
    const handleAttemptExceed = (res) => {
        if (res.lngLastWrongAttemptTime) {
            setWaitTimeInMin(30 - (Math.ceil(Date.now() / (1000 * 60) - (res.lngLastWrongAttemptTime / (1000 * 60)))));
            const interval = setInterval(() => {
                setWaitTimeInMin((prevTimer) => {
                    if (prevTimer === 0) {
                        setNoOfAttempts(0);
                        clearInterval(interval);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 60000);
        }
    };
    const onFinishFailed = (errorInfo) => {
    };
    const handleResendOTP = () => {
        setResendButtonTimmer();
        setIsResendOTPBttnDisabled(true);
        commonService.generateOTPForApprClientLogin(userDetail).then((res) => {
            if (res) {
                setValidateOTP(true);
                setUserDetail(res);
                messageApi.open({
                    type: res.boolOTPSent ? 'success' : 'error',
                    content: res.strOTPLoginMssg,
                });
            }
        });
    };
    const onFinishUserCategoryAdmin = (values) => {
        setBtnItrLoading(true);
        if (values.selCompany) {
            handleClientVendor(values.selCompany);
        }
    };
    const isClient = (companyId) => {
        commonService.checkClient(companyId)
            .then((res) => {
            if (res) {
                handleLogin(1, companyId, '/dashboard');
            }
        });
    };
    const onFinishUserRoleSel = (values) => {
        setBtnClientVendorLoading(true);
        if (selCompanyId) {
            if ((values === null || values === void 0 ? void 0 : values.role) === 1) {
                handleLogin(values === null || values === void 0 ? void 0 : values.role, selCompanyId, '/dashboard');
            }
            else if ((values === null || values === void 0 ? void 0 : values.role) === 2) {
                handleLogin(values === null || values === void 0 ? void 0 : values.role, selCompanyId, '');
            }
        }
    };
    const fetchVendorRelatedData = (companyId) => {
        commonService.getVendorClients(companyId).then((res) => {
            dispatch(setVendorClients(res));
        });
        commonService.getVendorSubProjCountries(companyId).then((res) => {
            dispatch(setVendorSubPrjCountries(res));
        });
        commonService.getVendorSubProjServiceTypes(companyId).then((res) => {
            dispatch(setVendorSubProjServiceTypes(res));
        });
        commonService.getVendorSubProjProdSubSeg(companyId).then((res) => {
            dispatch(setVendorSubProjProdSubSeg(res));
        });
        commonService.getVendorSubProjTechType(companyId).then((res) => {
            dispatch(setVendorSubProjTechType(res));
        });
        commonService.getVendorSubProjAssignees(companyId).then((res) => {
            dispatch(setVendorSubProjAssignees(res));
        });
        commonService.getVendorSubProjBussinessUnits(companyId).then((res) => {
            /*let businessUnits = res?.map((item) => {
                return {
                    intId : item?.intBusinessUnitId,
                    strLongDesc : item?.strBusinessUnitName
                }
            });*/
            dispatch(setVendorSubProjBussinessUnits(res));
        });
        commonService.getVendorSubProjBrandNames(companyId).then((res) => {
            dispatch(setVendorSubProjBrandNames(res));
        });
        commonService.getVendorPortalNotificationList(companyId).then((res) => {
            dispatch(setVendorPortalNotificationList(res));
        });
    };
    const fetchClientRelatedData = (selClientList, companyId, dispatch) => {
        if (selClientList && selClientList.length) {
            // commonService.getSubscriptionDetails({ intCompanyId: companyId, strUserId: userDetail?.strUserEmailId })
            //     .then((res: AccessRoleResponse) => {
            //         dispatch(setSubscriptionDetails(res));
            //     })
            commonService.getModelNames(selClientList).then((res) => {
                dispatch(setModelNames(res));
            });
            // commonService.getServiceCode(selClientList).then((res: LuService[]) => {
            //     dispatch(setServiceCode(res));
            // });
            commonService.getModelNamesWithIAProjects(selClientList).then((res) => {
                dispatch(setModelNamesWithIAProjects(res));
            });
            commonService.getModelNamesCertProjects(selClientList).then((res) => {
                dispatch(setModelNamesCertProjects(res));
            });
            commonService.getAllNotificationsCount(selClientList, 'getAllFANotificationsCount').then((res) => {
                dispatch(setFactoryAuditNotifyCount(res));
            });
            commonService.getAllNotificationsCount(selClientList, 'getCertExpInSixMonthCount').then((res) => {
                dispatch(setCertExpInSixMonthCount(res));
            });
            commonService.getAllNotificationsCount(selClientList, 'getCertRenewalReminderCount').then((res) => dispatch(setCertRenewalReminderCount(res)));
            commonService.getAllNotificationsCount(selClientList, 'getLastTwoMonthUpdRegCount').then((res) => dispatch(setLastTwoMonthUpdRegCount(res)));
            commonService.getAllNotificationsCount(selClientList, 'getReqUpdLastTwoMonthCount').then((res) => dispatch(setReqUpdLastTwoMonthCount(res)));
            commonService.getBVLocationList(selClientList).then((res) => {
                dispatch(setBvLocations(res));
            });
            commonService.getBVLocationCertList(selClientList).then((res) => {
                dispatch(setBvCertLocations(res));
            });
            commonService.getCountryCertProjects(selClientList).then((res) => {
                dispatch(setCountryCertProjects(res));
            });
            commonService.getWoModelNames(selClientList).then((res) => {
                dispatch(setWoModelNames(res));
            });
            commonService.getWoCountry(selClientList).then((res) => {
                dispatch(setWoCountry(res));
            });
            commonService.getClientProductlst(selClientList).then((res) => {
                dispatch(setClientProductlst(res));
            });
            commonService.getBrandNames(selClientList).then((res) => {
                dispatch(setBrandNames(res));
            });
            commonService.getIACertUploadProjectBrandNames(selClientList).then((res) => {
                dispatch(setCertIAUploadProjectBrandNames(res));
            });
            commonService.getBrandNamesWithIAProjects(selClientList).then((res) => {
                dispatch(setBrandNamesWithIAProjects(res));
            });
            commonService.getBrandNamesCertProjects(selClientList).then((res) => {
                dispatch(setBrandNamesCertProjects(res));
            });
            commonService.getWoBrandNames(selClientList).then((res) => {
                dispatch(setWoBrandNames(res));
            });
            mdmService.getClientProfileDetails({ intCompanyID: companyId, strUserId: userDetail === null || userDetail === void 0 ? void 0 : userDetail.strUserEmailId }).then((res) => {
                dispatch(setClientProfileDetails(res));
            });
            commonService.getProjectPieChartSearchList(selClientList).then((res) => {
                dispatch(setProjectPieChartSearchList(res));
            });
            // commonService.getClientUserScreenAccess(selClientList).then((res: Dropdown[]) => {
            //     dispatch(setClientUserScreenAccess(res));
            // })
        }
    };
    const fetchBasicData = () => {
        commonService.getApplicationLuData().then((data) => {
            dispatch(setCountryTerritoryList(getOrderedJson(data[API_CONSTANTS.APPR_COUNTRY_LIST], ["strLongDesc"], ["asc"])));
            dispatch(setCountryTerritoryList(getOrderedJson(data[API_CONSTANTS.APPR_COUNTRY_LIST], ["strLongDesc"], ["asc"])));
            dispatch(setProductTypeList(getOrderedJson(data[API_CONSTANTS.APPR_PROD_MAIN_SUB_JOINED_LIST], ["strLongDesc"], ["asc"])));
            dispatch(setServiceTypeList(getOrderedJson(data[API_CONSTANTS.APPR_SERVICE_TYPE_LIST], ["strLongDesc"], ["asc"])));
            dispatch(setTechnologyTypeList(getOrderedJson(data[API_CONSTANTS.APPR_TECH_TYPE_LIST], ["strLongDesc"], ["asc"])));
            dispatch(setMainProductTypeList(getOrderedJson(data[API_CONSTANTS.APPR_MP_PROD_TYPE_LIST], ["strLongDesc"], ["asc"])));
            dispatch(setRegionCountryList(getOrderedJson(data[API_CONSTANTS.APPR_MP_REGION_COUNTRY_LIST], ["strLongDesc"], ["asc"])));
            dispatch(setDocumentStatusList(getOrderedJson(data[API_CONSTANTS.APPR_REG_LIB_STATUS_LIST], ["strLongDesc"], ["asc"])));
            dispatch(setVendorCurrencyList(getOrderedJson(data[API_CONSTANTS.VENDOR_CURRENCY_LIST], ['strLongDesc'], ['asc'])));
            dispatch(setVendorSampleList(getOrderedJson(data[API_CONSTANTS.VENDOR_SAMPLE_LIST], ['strLongDesc'], ['asc'])));
        });
    };
    const thresholds = [
        { limit: 340, multiplier: 9 },
        { limit: 380, multiplier: 8 },
        { limit: 440, multiplier: 6.5 },
        { limit: 480, multiplier: 4.5 },
        { limit: 540, multiplier: 3.5 },
        { limit: 580, multiplier: 2 },
        { limit: 640, multiplier: 1.5 },
        { limit: 700, multiplier: 1 }
    ];
    useEffect(() => {
        const calculateDimensions = () => {
            let height = window.innerHeight;
            let width = height;
            for (const { limit, multiplier } of thresholds) {
                if (height < limit) {
                    width = height * multiplier;
                }
            }
            setDimensions({ height, width });
        };
        calculateDimensions();
        window.addEventListener("resize", calculateDimensions);
        return () => window.removeEventListener("resize", calculateDimensions);
    }, []);
    function model(email) {
        Modal.destroyAll();
        Modal.confirm({
            title: 'Information Notice',
            content: (_jsxs("div", { children: [_jsxs("div", { style: { maxHeight: '300px', overflowY: 'auto' }, children: [_jsx("center", { children: _jsx("h4", { children: "INFORMATION NOTICE TO DATA SUBJECTS" }) }), _jsx("b", { children: "(If you are receiving this notice on behalf of one or more data subjects, please give a copy of this notice to the data subject(s).)" }), _jsx("p", { children: "Your personal data (i.e. your e-mail address) is collected by Bureau Veritas Consumer Products Services, through its entity Bureau Veritas Hong Kong Limited, having its registered office at 2/F, Pacific Trade Centre, 2 Kai Hing Road, Kowloon Bay, Kowloon, Hong Kong (\u201CBVCPS\u201D), and is subject to computer processing in order to allow you to log in to the BVOneSource site (the \u201CSite\u201D) and receive automatic e-mails through the Site\u2019s applications, based on the legitimate interests pursued by BVCPS in providing you access to and use of the Site for the purpose of performing the services owed to your employer under its agreement with BVCPS." }), _jsx("p", { children: "BVCPS collects and processes your e-mail address. This data is provided by you or another individual in your organization on an application form or in an e-mail request for use of the Site. Your personal data is intended for BVCPS. It will be retained until the earlier of (a) 7 years after deactivation of your account upon termination of your employer\u2019s agreement with BVCPS (i.e. on average 1 to 5 years after its effective date or its renewal date), or (b) your or your employer\u2019s request for deactivation of your account." }), _jsx("p", { children: "Your personal data may be transferred outside the European Union (in particular to the United States of America), on the basis of your explicit consent, as the data subject, to the proposed transfer. You are hereby providing your explicit consent to the proposed transfer, with your acknowledgement of the possible risks of such transfer due to the absence of an adequacy decision pursuant to Article 45 of the General Data Protection Regulation of 27 April 2016 or of appropriate safeguards pursuant to Article 46 of the General Data Protection Regulation of 27 April 2016." }), _jsxs("p", { children: ["In accordance with the French Data Protection Act of 6 January 1978 as amended and the General Data Protection Regulation of 27 April 2016, you have the right to access, rectify and erase any personal data concerning you, as well as the right to limit the processing, the right to oppose to the processing or the right to portability of your personal data. You have the right to withdraw your consent to the transfer of your personal data at any time. You also have the right to set out general and specific guidelines that define how you intend these rights to be exercised after your death. You can exercise your rights by e-mail at the following address:", _jsx("a", { href: "https://personaldataprotection.bureauveritas.com", children: "https://personaldataprotection.bureauveritas.com" }), ". Finally, you have a right to lodge a complaint to the Commission Nationale Informatique et Libert\u00E9s (CNIL)."] })] }), _jsx(Checkbox, { style: { color: 'red' }, onChange: handleCheckboxChange, children: "I agree to the terms and conditions." }), ' '] })),
            okText: 'Accept',
            cancelText: 'Decline',
            okButtonProps: {
                style: { backgroundColor: '#00a4a4', borderColor: '#00a4a4', color: '#fff' }
            },
            cancelButtonProps: {
                style: { color: '#000' }
            },
            onOk: () => handleconsentOk(email),
            onCancel: handleconsentCancel,
            width: 600
        });
    }
    return (_jsxs(Flex, { justify: 'center', align: 'center', style: { minHeight: '100vh' }, children: [contextHolder, _jsx(Spin, { size: "default", spinning: btnOvrItrLoading || btnItrLoading || btnClientVendorLoading, children: _jsx(Flex, { children: _jsxs(Row, { gutter: [16, 16], style: {
                            // height: `${dimensions.height}px`,
                            width: width > 780 ? `${dimensions.width}px` : 'unset',
                            minHeight: `300px`,
                            minWidth: width > 780 ? `580px` : 'unset',
                            border: "4px solid #43485F",
                        }, children: [width > 780 &&
                                _jsxs(Col, { xs: 11, sm: 11, md: 11, lg: 11, xl: 11, style: { background: '#43485F' }, children: [_jsx(Row, { gutter: [16, 16], children: _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsx("img", { src: one_source_connect, alt: "Description of the image", style: { background: '#43485F', width: '180px', height: 'auto' } }) }) }), _jsx(Row, { gutter: [16, 16], children: _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsxs(Flex, { style: { height: '40vh', flexDirection: 'column', padding: '10px' }, justify: 'space-between', children: [_jsx(Typography.Text, { style: { color: 'white' }, children: "Bureau Veritas is a world leading provider of conformity assessment solutions to the consumer product services market" }), _jsxs(Space, { direction: 'vertical', size: 'small', children: [_jsx(Divider, { orientation: "left", plain: true, style: { margin: '0px', color: 'white', borderBlockStart: 'white' }, children: "Approvals" }), _jsx(Typography.Text, { style: { color: 'white' }, children: "Track progress and maintain certificate compliance for your electronics, automotive and wireless international approval projects." })] })] }) }) })] }), _jsxs(Col, { xs: width > 780 ? 13 : 24, sm: width > 780 ? 13 : 24, md: width > 780 ? 13 : 24, lg: width > 780 ? 13 : 24, xl: width > 780 ? 13 : 24, children: [showUserRoleMenu && _jsxs(Form, { name: "userCategoryAdmin", initialValues: { remember: true }, onFinish: onFinishUserRoleSel, style: {
                                            height: '50vh',
                                            alignContent: 'space-around',
                                            padding: '20px'
                                        }, children: [_jsx(Typography.Title, { level: 3, style: { color: '#43485F' }, children: "Select Role" }), _jsx(Form.Item, { name: "role", rules: [{ required: true, message: 'Please select role' }], children: _jsxs(Radio.Group, { value: 1, children: [_jsx(Radio, { value: 1, children: "Client" }), _jsx(Radio, { value: 2, children: "Vendor" })] }) }), _jsx(Form.Item, { children: _jsx(Button, { type: "primary", loading: btnClientVendorLoading, htmlType: "submit", style: { width: '-webkit-fill-available' }, children: "Enter" }) })] }), showCompSelMenu && _jsxs(Form, { name: "userCategoryAdmin", initialValues: { remember: true }, onFinish: onFinishUserCategoryAdmin, style: {
                                            height: '50vh',
                                            alignContent: 'space-around',
                                            padding: '20px'
                                        }, children: [_jsx(Typography.Title, { level: 3, style: { color: '#43485F' }, children: "Proceed to Approvals Dashboard" }), _jsx(Form.Item, { name: "selCompany", rules: [{ required: true, message: 'Please select company' }], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, placeholder: "Select Company", options: convertCompanyDataToSelectOptions(companies) }) }), _jsx(Form.Item, { children: _jsx(Button, { type: "primary", loading: btnItrLoading, htmlType: "submit", style: { width: '-webkit-fill-available' }, children: "Enter" }) })] }), _jsxs(Form, { name: "login", id: "loginForm", initialValues: { remember: true }, onFinish: onFinish, style: {
                                            height: '50vh',
                                            alignContent: 'space-around',
                                            padding: '20px'
                                        }, form: form, onFinishFailed: onFinishFailed, hidden: showCompSelMenu || showUserRoleMenu, children: [_jsx(Typography.Title, { level: 3, style: { color: '#43485F' }, children: !validateOTP ? 'Log in to your account' : 'OTP Validation' }), _jsx(Form.Item, { name: "strUserEmailId", rules: [{ required: true, message: 'Please input your Email!' },
                                                    { type: 'email', message: 'The input is not a valid email!' }
                                                ], children: _jsx(Input, { placeholder: "User email", prefix: _jsx(UserOutlined, {}), disabled: validateOTP }) }), validateOTP &&
                                                _jsx(Form.Item, { name: "strEnteredOTP", rules: [{ required: true, message: 'Please input OTP!' }], children: _jsx(Flex, { align: 'center', justify: 'center', children: _jsx(Input.OTP, { onChange: _ => setEnteredOTP(_), length: 6 }) }) }), validateOTP ?
                                                _jsxs(_Fragment, { children: [_jsx(Form.Item, { children: _jsx(Button, { type: "primary", htmlType: "submit", style: { width: '-webkit-fill-available' }, disabled: noOfAttempts >= 5, children: noOfAttempts >= 5 ? `Please try again after ${waitTimeInMin} minutes` : `Validate OTP (no. of attempts left: ${5 - noOfAttempts})` }) }), !(noOfAttempts >= 5) && _jsxs(Flex, { align: 'center', justify: 'space-between', children: [_jsx(Typography.Text, { children: "Didn't receive the verification OTP?" }), _jsxs(Link, { onClick: handleResendOTP, disabled: isResendOTPBttnDisabled, children: ["Resend OTP ", isResendOTPBttnDisabled && `in ${timer}s`] })] })] })
                                                :
                                                    _jsx(Form.Item, { children: _jsx(Button, { type: "primary", id: "generateOTPButton", htmlType: "submit", loading: loading, style: { width: '-webkit-fill-available' }, disabled: noOfAttempts >= 5, children: noOfAttempts >= 5 ? `Please try again after ${waitTimeInMin} minutes` : `Generate OTP` }) })] })] })] }) }) })] }));
};
export default LoginPage;
